import { render, staticRenderFns } from "./CompaniesTable.vue?vue&type=template&id=5fd306d6&scoped=true&lang=pug&"
import script from "./CompaniesTable.vue?vue&type=script&lang=js&"
export * from "./CompaniesTable.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesTable.vue?vue&type=style&index=0&id=5fd306d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd306d6",
  null
  
)

export default component.exports